/* eslint-disable */
export default (ctx) => {
  const options = {"enabled":false,"invalidation":{"endpoint":"\u002Fcache-clean","key":"01067ce0f656a916e97d1829510425a9","handlers":["@bee-hole\u002Fcache\u002FdefaultHandler"]},"driver":["@bee-hole\u002Fcache\u002Fdrive\u002Fredis",{"defaultTimeout":86400,"redis":{"host":"127.0.0.1","port":6379,"password":"","keyPrefix":""}}]};

  ctx.req.$vsfCache = {
    ...options,
    tagsSet: new Set()
  };
}
